import { Button, Tooltip } from "@mui/material";
import { CohortMemberStatus, CohortStatus } from "generated-graphql/graphql";

interface SplitCohortButtonProps {
  onClick: () => void;
  cohortStatus: CohortStatus;
  members: Array<{ status: CohortMemberStatus }>;
  variant?: "contained" | "outlined" | "text";
  color?: "primary" | "secondary" | "warning" | "error" | "info" | "success";
  fullWidth?: boolean;
  sx?: any;
  children?: React.ReactNode;
}

export function SplitCohortButton({
  onClick,
  cohortStatus,
  members,
  variant = "outlined",
  color = "warning",
  fullWidth = false,
  sx = {},
  children = "Split Cohort",
}: SplitCohortButtonProps) {
  const isCohortClosed = cohortStatus === CohortStatus.Closed;
  const readyMembersCount = members.filter(
    (member) => member.status === CohortMemberStatus.Ready
  ).length;

  const isButtonEnabled = !isCohortClosed && readyMembersCount > 0;

  const getTooltipText = () => {
    if (isCohortClosed) {
      return "Cannot split a closed cohort";
    }
    if (readyMembersCount === 0) {
      return "No ready members to split";
    }
    return "";
  };

  return (
    <Tooltip title={getTooltipText()} disableHoverListener={isButtonEnabled}>
      <span>
        <Button
          variant={variant}
          color={color}
          onClick={onClick}
          disabled={!isButtonEnabled}
          fullWidth={fullWidth}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            ...sx,
          }}
        >
          {children}
        </Button>
      </span>
    </Tooltip>
  );
}
